<template>
    <div>
        <BodycheckItem />
    </div>
</template>

<script>
import BodycheckItem from "./bodycheckItemView.vue";
export default {
    components: {
        BodycheckItem,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
